import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import {
    resolveReportRequest,
    resolveReportSuccess,
    resolveReportError,
} from '../../slices/support/ResolveReportSlice';

export const ResolveReportAPI = (id) => async (dispatch) => {
    try {
        dispatch(resolveReportRequest());
        axiosInstance({
            method: 'PATCH',
            url: `${endpoints.resolveReport}/${id}/resolve`,
            headers: { 'Content-Type': 'application/json' },
        })
            .then((resp) => dispatch(resolveReportSuccess(resp?.data)))
            .catch((error) => {
                dispatch(resolveReportError({
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                }));
            });
    } catch (error) { }
};

